import React from "react"
import Tabs from "../Tabs/Tabs"
import PortalReservationPresenterWorkspace from "./PortalReservationPresenterWorkspace"

class PortalReservationPresenter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      active_tab: 'summary',
      currency: {id: 'USD|$|1', name: 'United States Dollar', iso_code: 'USD', symbol: '$', exchange_rate: 1},
      terms_visible: false,

    }

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onToggleTerms = this.onToggleTerms.bind(this);
  }

  render() {
    return (
      <div className="PortalReservationPresenter">
        <Tabs tabs={this.tabs()}/>
        <PortalReservationPresenterWorkspace {...this.props} {...this.state} onToggleTerms={this.onToggleTerms} />
        {this.renderTerms()}
      </div>
    );
  }

  renderTerms() {
    if (this.state.terms_visible) {
      return (
        <div className="fullscreen-terms">
          <div className="overlay"></div>
          <a href="#" className="close-button" onClick={this.onToggleTerms}>{I18n.t('hide_terms_and_conditions')}</a>
          <div ref="fullscreen_terms">
            <div className="terms-container">
              <div className="terms-text" dangerouslySetInnerHTML={{__html: this.generateTerms()}}></div>
              <div className="button-wrapper">
                <button type="button" className="btn" onClick={this.onToggleTerms}>{I18n.t('close')}</button>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  tabs() {
    var tabs = []

    tabs.push({
      tabName: I18n.t('summary'),
      targetName: 'summary',
      classes: this.state.active_tab === 'summary' ? 'active' : null,
      changeHandler: this.onChangeActiveTab,
    })

    tabs.push({
      tabName: I18n.t('transactions'),
      targetName: 'transactions',
      classes: this.state.active_tab === 'transactions' ? 'active' : null,
      changeHandler: this.onChangeActiveTab,
    })

    return tabs;
  };

  /*
  * Change handlers
  */

  onChangeActiveTab(active_tab) {
    this.setState({active_tab: active_tab, terms_visible: false});
  }

  onToggleTerms() {
    this.setState({terms_visible: !this.state.terms_visible})
  }

  /**
  * Helper functions
  */

  generateTerms() {
    var terms = {};
    var terms_string = '';

    // bundle up all rate billing policy terms
    var reservation_segment = this.props.reservation_segment;

    if (reservation_segment && reservation_segment.billing_policy) {
      if (terms.hasOwnProperty(reservation_segment.billing_policy.id)) {
        terms[reservation_segment.billing_policy.id].reservation_segments.push(reservation_segment);
      } else {
        terms[reservation_segment.billing_policy.id] = {
          terms: reservation_segment.billing_policy.terms,
          reservation_segments: [reservation_segment]
        }
      }
    }

    for (var t in terms) {
      terms_string = terms_string + terms[t].terms;
    }
    return terms_string;
  }
};

export default PortalReservationPresenter
